/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Marketing_Milestone_Banner_DismissInputs */



/**
* | output |
* | --- |
* | "Dismiss" |
*
* @param {Marketing_Milestone_Banner_DismissInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
export const marketing_milestone_banner_dismiss = /** @type {((inputs?: Marketing_Milestone_Banner_DismissInputs, options?: { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Marketing_Milestone_Banner_DismissInputs, { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Ausblenden")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Masquer")
	if (locale === "zh-Hans") return /** @type {LocalizedString} */ ("关闭")
	if (locale === "zh-Hant") return /** @type {LocalizedString} */ ("關閉")
	if (locale === "ko") return /** @type {LocalizedString} */ ("닫기")
	return /** @type {LocalizedString} */ ("Dismiss")
});